<template>
  <base-spinner v-if="loading" />
  <div v-else>
    <div>
      <div class="row align-items-center mb-2">
        <div class="col-6">
          <h5 class="result">{{ total }} {{ $t("results") }}</h5>
        </div>
        <div class="col-6 d-flex align-items-center justify-content-between flex-wrap">
          <div class="d-flex align-items-center justify-content-between flex-wrap"></div>
          <div class="d-flex justify-content-end mb-2 mb-lg-0 flex-wrap">
            <div class="mb-2">
              <base-button id="tax_types_filter_btn" variant="secondary" cus_style="padding:12px 16px"
                class="me-2 filter__btn" v-b-toggle.sidebar-backdrop @mouseenter="filterBtnHovered = true"
                @mouseleave="filterBtnHovered = false">
                <img :src="filterBtnHovered
                  ? require(`@/assets/images/icons/funnel-simple-bold-svgrepo-com.png`)
                  : require(`@/assets/images/icons/funnel-simple-bold-svgrepo-com.png`)
                  " alt="filter" />
              </base-button>
            </div>

            <!-- Filter LIst -->
            <div class="custom-filter filter-list">
              <b-sidebar id="sidebar-backdrop" :backdrop-variant="variant" bg-variant="white" backdrop
                :right="!isLangRtl" shadow>
                <div class="px-3 py-2">
                  <div>
                    <h4 class="custom-filter__head pt-2">
                      {{ $t("filter-by") }}
                    </h4>
                    <validation-observer ref="observer">
                      <form @submit.prevent="handleForm">
                        <h5 class="filter-input-title pt-2">
                          {{ $t("general") }}
                        </h5>
                        <hr />

                        <base-input type="text" label="file-name" name="fileName" placeholder="file-name" id="filename"
                          field="fileName" :value="searchPayload.fileName" @change-value="setValue" :small="true">
                        </base-input>

                        <base-input type="number" label="total-records" id="total-records" name="totalRecords" placeholder="total-records"
                          field="totalRecords" :small="true" :value="searchPayload.totalRecords" @change-value="setValue">
                        </base-input>

                        <base-input type="number" label="failed-imports" id="failed-imports" name="failedImports" placeholder="failed-imports"
                          field="failedImports" :small="true" :value="searchPayload.failedImports" @change-value="setValue">
                        </base-input>
                        <base-select
                          name="Resource Type"
                          label="resource-type"
                          :options="resourceTypeList"
                          :small="true"
                          field="resourceType"
                          :value="searchPayload.resourceType"
                          @change-value="getResourceType"
                        >
                        </base-select>
                        <base-select
                          name="Status"
                          label="status"
                          :options="statusList"
                          :small="true"
                          field="status"
                          :value="searchPayload.status"
                          @change-value="getStatus"
                        >
                        </base-select>

                        <div>
                          <div class="row mb-2">
                            <h5 class="filter-input-title pt-2 mt-3 mb-2">
                              {{ $t("date-range") }}
                            </h5>
                            <div class="col-6">
                              <div class="form-label label-text">
                                {{ $t("from") }}
                              </div>
                              <validation-provider :rules="searchPayload.toDate ? '' : ''" name="Transaction Date From"
                                v-slot="{ errors }">
                                <div class="input-group">
                                  <b-modal :id="modalTransactionDateFrom" ref="modalTransactionDateFrom" centered
                                    hide-header hide-footer no-fade static content-class="w-auto mx-auto">
                                    <b-calendar v-model="searchPayload.fromDate" @context="
                                      (ctx) => (ContextTransactionDateFrom = ctx)
                                    " @input="$refs.modalTransactionDateFrom.hide()">
                                    </b-calendar>
                                  </b-modal>
                                  <b-input-group v-b-modal="modalTransactionDateFrom">
                                    <label
                                      class="form-control input-time-group d-flex flex-row justify-content-between align-items-center cursor-pointer">
                                      <span v-if="!ContextTransactionDateFrom.selectedYMD" class="time-placeHolder">{{
                                        $t("select-date") }}</span>
                                      {{ ContextTransactionDateFrom.selectedYMD }}
                                      <img :src="require(`@/assets/images/icons/select-time.svg`)
                                        " alt="select time" />
                                    </label>
                                  </b-input-group>
                                </div>
                                <div class="form-label error-text">
                                  <span>{{ errors[0] }}</span>
                                </div>
                              </validation-provider>
                            </div>
                            <div class="col-6">
                              <div class="form-label label-text">
                                {{ $t("to") }}
                              </div>
                              <validation-provider :rules="{
                                oldest_date: {
                                  dates: [
                                    searchPayload.fromDate || '1970-01-01',
                                    searchPayload.toDate,
                                  ],
                                },
                              }" name="Transaction Date To" v-slot="{ errors }">
                                <div class="input-group">
                                  <b-modal :id="modalTransactionDateTo" ref="modalTransactionDateTo" centered
                                    hide-header hide-footer no-fade static content-class="w-auto mx-auto">
                                    <b-calendar v-model="searchPayload.toDate" @context="
                                      (ctx) => (ContextTransactionDateTo = ctx)
                                    " @input="$refs.modalTransactionDateTo.hide()">
                                    </b-calendar>
                                  </b-modal>
                                  <b-input-group v-b-modal="modalTransactionDateTo">
                                    <label
                                      class="form-control input-time-group d-flex flex-row justify-content-between align-items-center cursor-pointer">
                                      <span v-if="!ContextTransactionDateTo.selectedYMD" class="time-placeHolder">{{
                                        $t("select-date") }}</span>
                                      {{ ContextTransactionDateTo.selectedYMD }}
                                      <img :src="require(`@/assets/images/icons/select-time.svg`)
                                        " alt="select time" />
                                    </label>
                                  </b-input-group>
                                </div>
                                <div class="form-label error-text">
                                  <span>{{ errors[0] }}</span>
                                </div>
                              </validation-provider>
                            </div>
                          </div>
                        </div>

                        <base-button class="search-btn primary mt-4 mb-3" :disabled="loading" type="submit"
                          id="receipt-voucher-submit-btn">
                          {{ $t("search") }}
                        </base-button>
                        <base-button id="receipt-voucher-reset-btn" class="reset-btn mb-1" @click="resetSearchPayload">
                          {{ $t("reset-filters") }}
                        </base-button>
                      </form>
                    </validation-observer>
                  </div>
                </div>
              </b-sidebar>
            </div>
          </div>
        </div>
      </div>
    </div>
    <hr />
    <div>
      <div>
        <b-alert :show="error && error.length ? true : false" variant="danger">
          <div v-html="error || '&nbsp;'"></div>
        </b-alert>
        <div class="col-12">
          <b-table :items="items" :fields="fields" :hover="true" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc"
            :per-page="perPage" :current-page="1" label-sort-asc="" label-sort-desc="" label-sort-clear=""
            sort-icon-right show-empty :no-border-collapse="true" responsive="lg"
            thead-class="table-thead text-center bg-transparent " tbody-class="table-tbody text-center cursor-pointer"
            ref="selectableTable" info="true" class="new-theme-custom-table"
            @row-clicked="(feedback) => showFeedbackDetails(feedback)">
            <template #empty> {{ $t("empty-row") }} </template>
            <template #cell(linked_account)="{ item }">
              <div class="d-flex justify-content-between pe-2 align-items-center">
                <div>
                  {{ item.linked_account }}
                </div>
                <b-dropdown variant="transparent">
                  <div class="d-flex flex-column justify-content-center delete-edit-model">
                    <div id="tax_types_edit" class="d-flex justify-content-center delete-edit-model-text"
                      @mouseenter="editHovered = true" @mouseleave="editHovered = false"
                      @click.stop="moveToEdit(item.id)">
                      <img :src="editHovered
                        ? require('@/assets/images/icons/pincle-edit.svg')
                        : require('@/assets/images/icons/pincle-edit.svg')
                        " alt="edit" width="13" />
                      <p class="text-center my-2 mx-3">{{ $t("details") }}</p>
                    </div>
                  </div>
                </b-dropdown>
              </div>
            </template>
            <template #cell(processed)="{ item }">
              <div class="d-flex flex-column align-items-start">
                <div class="w-100">
                  <b-progress  max="100" height="12px" :show-progress="false">
                    <b-progress-bar :value="computePercent(item)">
                    </b-progress-bar>
                  </b-progress>
                </div>
              </div>
            </template>
            <template #cell(download)="{ item }">
              <a
                v-if="item.fileUrl"
                :href="item.fileUrl"
                target="_blank"
                rel="noopener noreferrer"
                class="btn btn-sm btn-outline-primary"
              >
                {{ $t("download") }}
              </a>
              <span v-else class="text-muted">-</span>
            </template>
          </b-table>
          <b-pagination v-if="total" v-model="currentPage" :total-rows="total" :per-page="perPage" first-number
            last-number aria-controls="my-table" class="d-flex justify-content-end"></b-pagination>
        </div>
      </div>
    </div>
    <b-sidebar :visible="isDetailsShown" id="transaction-detail-sidebar-backdrop" bg-variant="white" backdrop
      :right="!isLangRtl" shadow width="70%" @hidden="hideFeedbackDetails">
      <LogDetails v-if="selectedResourceLog" :resourceData="selectedResourceLog" />
    </b-sidebar>
  </div>
</template>

<script>
import ResourceLogService from "@/services/resource-log.service";
import moment from "moment";
import LogDetails from "./logDetails.vue";

export default {
  components: {
    LogDetails
  },
  data() {
    return {
      loading: false,
      error: null,
      editHovered: false,
      filterBtnHovered: false,
      sortBy: "",
      sortDesc: false,
      perPage: 10,
      currentPage: 1,
      total: 0,
      modalTransactionDateFrom: "date-picker-transactionDateFrom",
      modalTransactionDateTo: "date-picker-transactionDateTo",
      ContextTransactionDateFrom: {},
      ContextTransactionDateTo: {},
      statusList: [{ value: "PENDING", text: "Pending" }, { value: "IN_PROGRESS", text: "In Progress" }, { value: "PROCESSED", text: "Processed" }],
      resourceTypeList: [{ value: "VEHICLE", text: "Vehicle" }, { value: "DRIVER", text: "Driver" }],
      fields: [
        {
          key: "id",
          label: this.$t("id"),
          sortable: true,
          class: "px-2 align-middle",
          thStyle: {
            backgroundPosition: "right 0.5rem center !important",
          },
        },
        {
          key: "fileName",
          label: this.$t("file-name"),
        },
        {
          key: "resourceType",
          label: this.$t("resource-type"),
          class: "px-2 align-middle",
          thStyle: {
            backgroundPosition: "right 0.5rem center !important",
          },
        },
        {
          key: "created_by",
          label: this.$t("created-by"),
          sortable: false,
        },
        {
          key: "uploadTimeKSA",
          label: this.$t("upload-time-ksa"),
          sortable: false,
        },
        {
          key: "totalRecords",
          label: this.$t("total-records"),
          sortable: true,
        },
        {
          key: "successfulImports",
          label: this.$t("successful-imports"),
          sortable: true,
        },
        {
          key: "failedImports",
          label: this.$t("failed-imports"),
          sortable: true,
        },
        {
          key: "processed",
          label: this.$t("processed"),
          sortable: false,
        },
        {
          key: "newResources",
          label: this.$t("new-resources"),
          sortable: true,
        },
        {
          key: "updatedResources",
          label: this.$t("updated-resources"),
          sortable: true,
        },
        {
          key: "status",
          label: this.$t("status"),
          sortable: false,
        },
        {
          key: "updated_on",
          label: this.$t("submission-date"),
          sortable: true,
        },
        {
          key: "download",
          label: this.$t("download"),
          sortable: false,
          class: "text-center",
        },
      ],
      variant: "transparent",
      items: [],
      selectedResourceLog: null,
      isDetailsShown: null,
      searchPayload: {
        fileName: null,
        resourceType: null,
        totalRecords: null,
        failedImports: null,
        status: null,
        fromDate: null,
        toDate: null
      },
    };
  },
  computed: {
  },
  methods: {
    setValue(val, field) {
      this.searchPayload[field] = val;
    },
    getStatus(status) {
      this.searchPayload.status = status;
    },
    getResourceType(resourceType) {
      this.searchPayload.resourceType = resourceType;
    },
    formatDate(date) {
      return moment(date).locale("en").format("DD-MM-YYYY");
    },
    formatDateKSA(date) {
      if (!date) return "-";
      return moment.utc(date).utcOffset(3).locale("en").format("DD-MM-YYYY HH:mm");
    },
    showFeedbackDetails(feedback) {
      this.isDetailsShown = true;
      ResourceLogService.get(feedback.id).then((data) => {
        this.selectedResourceLog = data;
      });
    },
    hideFeedbackDetails() {
      this.isDetailsShown = false;
      this.selectedResourceLog = null;
    },
    async handleForm() {
      const valid = await this.$refs.observer.validate();
      if (!valid) return;
      this.getData();
    },
    getData() {
      this.loading = true;
      this.error = null;
      this.total = 0;
      this.items = [];

      let params = new URLSearchParams();
      params.append("page", this.currentPage || 1);
      params.append("limit", this.perPage);
      params.append("sort", "-updated_on");

      if (this.searchPayload.fileName) params.append("fileName", this.searchPayload.fileName);
      if (this.searchPayload.resourceType) params.append("resourceType", this.searchPayload.resourceType);
      if (this.searchPayload.status) params.append("status", this.searchPayload.status);
      if (this.searchPayload.totalRecords) params.append("totalRecords", this.searchPayload.totalRecords);
      if (this.searchPayload.failedImports) params.append("failedImports", this.searchPayload.failedImports);

      if (this.searchPayload.fromDate) {
        params.append(
          "updated_on",
          "gte:" + this.searchPayload.fromDate + "T00:00:00.000Z"
        );
      }

      if (this.searchPayload.toDate) {
        params.append(
          "updated_on",
          "lte:" + this.searchPayload.toDate + "T23:59:59.000Z"
        );
      }

      ResourceLogService.search(params)
        .then(({ items, total }) => {
          this.items = items;
          this.total = total;
          this.loading = false;

          this.items = items?.map((each) => {
            return {
              id: each._id,
              fileName: each?.fileName,
              resourceType: this.$t(each?.resourceType.toLowerCase()).toUpperCase(),
              created_by: each?.created_by || "-",
              uploadTimeKSA: this.formatDateKSA(each?.created_on),
              totalRecords: each?.totalRecords || 0,
              successfulImports: each?.successfulImports || 0,
              failedImports: each?.failedImports || 0,
              processed: each?.processed,
              status: this.$t(each?.status.toLowerCase()).toUpperCase(),
              newResources: each?.newResources || 0,
              updatedResources: each?.updatedResources || 0,
              updated_on: this.formatDate(each?.updated_on),
              fileUrl: each?.fileUrl || null,
            };
          });
        })
        .catch(({ message }) => {
          this.error = message;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    computePercent(item) {
      const processed = Number(item.processed) || 0;
      const total = Number(item.totalRecords) || 0;
      if (!total) return 0;
      let pct = Math.round((processed / total) * 100);
      if (pct < 0) pct = 0;
      if (pct > 100) pct = 100;
      return pct;
    },
    resetSearchPayload() {
      this.searchPayload.fileName = null;
      this.searchPayload.totalRecords = null;
      this.searchPayload.fromDate = null;
      this.searchPayload.toDate = null;
      this.searchPayload.resourceType = null;
      this.searchPayload.status = null;
      this.searchPayload.failedImports = null;
      this.getData();
    },
  },
  watch: {
    currentPage(val) {
      if (val) this.getData();
    },
  },
  mounted() {
    this.getData();
  },
  created() {
    this.$store.dispatch("enums/GET_BRANCH_ENUMS");
  },
};
</script>
